var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-header",class:{ 'chart-header--inner-padding': _vm.innerPadding }},[_c('span',{staticClass:"chart-title"},[_vm._v(_vm._s(_vm.title))]),_vm._t("trailing")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }